export const styles = (theme) => {
	return {
		lowHeight: {
			height: "265px !important",
			[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
				height: "265px !important",
			},
			[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
				height: "auto",
			},
			[`@media (max-width: ${theme.media.sm})`]: {
				height: "auto !important",
			},
		},
		root: {
			width: "280px",
			height: "410px",
			borderRadius: "10px",
			backgroundColor: theme.palette.colors.white,
			border: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
			marginRight: "10px",
			marginLeft: "10px",
			marginBottom: "20px",
			position: "relative",
			padding: "30px 30px 25px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		wrapper: {
			width: "100%",
			height: "100%",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		counter: {
			position: "absolute",
			top: "14px",
			right: "14px",
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: 1.25,
			letterSpacing: "1.6",
			color: theme.palette.colors.oneMoreGrey,
		},
		logoWrapper: {
			width: "100%",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			marginBottom: "20px",
			height: "60px",
		},
		logo: {
			display: "flex",
			justifyContent: "center",
			maxWidth: "100%",
			maxHeight: "60px",
			objectFit: "scale-down",
		},
		logoPlaceholder: {
			display: "flex",
			justifyContent: "center",
			background: theme.palette.colors.disabled,
		},
		infoWrapper: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			marginBottom: "20px",
		},
		infoNameWrapper: {},
		amountTariffsWrapper: {},
		subtext: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			textTransform: "uppercase",
		},
		subtextMeasure: {
			marginTop: "14px",
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			textTransform: "uppercase",
		},
		nameWrapper: {
			minHeight: "40px",
			width: "100%",
			textAlign: "center",
			marginBottom: "8px",
		},
		name: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: 1.25,
			color: theme.palette.colors.darkSlateBlue,
			textAlign: "center",
		},
		measuresWrapper: {
			marginBottom: "28px",
		},
		priceWrapper: {
			width: "100px",
			textAlign: "left",
			marginBottom: "20px",
		},
		speedWrapper: {
			width: "100px",
			textAlign: "left",
		},
		mainText: {
			display: "flex",
			flexDirection: "column",
			fontFamily: theme.fonts.bold,
			fontSize: "24px",
			lineHeight: "1",
			letterSpacing: "-.5px",
			color: theme.palette.colors.darkSlateBlue2,
			// marginBottom: "12px",
		},
		buttons: {
			marginTop: "auto",
			width: "100%",
		},
		buttonsItem: {
			height: "40px",
			borderRadius: "10px",
			border: `solid 1px ${theme.palette.colors.purplishBlue}`,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			width: "100%",
			textTransform: "uppercase",
			cursor: "pointer",
			userSelect: "none",
		},
		buttonsItemText: {
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			lineHeight: 1.29,
			letterSpacing: "1.6px",
			color: theme.palette.colors.purplishBlue,
		},
		isElite: {
			border: `1px solid ${theme.palette.colors.purplishBlue}`,
		},
		absorbWrapper: {},
		absorbItem: {},
		absorbItemSecond: {},
		absorbArrow: {},
		absorbArrowText: {},
		absorbArrowWrapper: {
			textAlign: "center",
		},
		isAbsorb: {
			"& $absorbWrapper": {
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			},
			"& $absorbItem": {
				width: "100%",
				display: "flex",
				justifyContent: "center",
				flexWrap: "wrap",
			},
			"& $absorbItemSecond": {
				width: "100%",
				"& $logoWrapper": {
					marginBottom: "10px",
				},
			},
			"& $nameWrapper": {
				minHeight: 0,
				marginBottom: 0,
			},
			"& $absorbArrowWrapper": {
				margin: "20px 0",
			},
			"& $absorbArrow": {
				color: theme.palette.colors.disabled,
				fontSize: "24px",
			},
			"& $absorbArrowText": {
				color: theme.palette.colors.disabled,
				fontFamily: theme.fonts.medium,
				fontSize: "12px",
				letterSpacing: "2px",
				textTransform: "uppercase",
				marginBottom: "5px",
			},
		},
		isFlat: {
			width: "100%",
			height: "100px",
			margin: 0,
			padding: "0 30px",
			flexDirection: "row",
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			borderTop: "none",
			borderRadius: 0,
			"&:first-child": {
				borderTopLeftRadius: "10px",
				borderTopRightRadius: "10px",
				borderTop: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			},
			"&:last-child": {
				borderBottomLeftRadius: "10px",
				borderBottomRightRadius: "10px",
			},
			"& $wrapper": {
				flexDirection: "row",
			},
			"& $counter": {
				display: "none",
			},
			"& $infoWrapper": {
				flexDirection: "row",
				marginBottom: 0,
			},
			"& $measuresWrapper": {
				display: "flex",
				flexDirection: "row",
				marginBottom: 0,
			},
			"& $priceWrapper": {
				marginBottom: 0,
				marginRight: "40px",
			},
			"& $logoWrapper": {
				marginBottom: 0,
				width: "130px",
				height: "60px",
				marginRight: "64px",
				flexShrink: 0,
			},
			"& $logo": {
				height: "auto",
			},
			"& $nameWrapper": {
				minHeight: 0,
				textAlign: "left",
				width: "260px",
				paddingRight: "20px",
				flexShrink: 0,
				textOverflow: "ellipsis",
				overflow: "hidden",
			},
			"& $name": {
				textAlign: "left",
				textOverflow: "ellipsis",
				overflow: "hidden",
				whiteSpace: "nowrap",
			},
			"& $buttons": {
				marginTop: 0,
				width: "270px",
				display: "flex",
				marginLeft: "auto",
			},
			"& $buttonsItem": {
				width: "100%",
				borderRadius: "10px",
			},
			"&$isElite": {
				borderTop: "none",
				border: `solid 1px ${theme.palette.colors.purplishBlue}`,
				"&:first-child": {
					borderTop: `solid 1px ${theme.palette.colors.purplishBlue}`,
				},
			},
			"&$isAbsorb": {
				"& $absorbWrapper": {
					flexDirection: "row",
					alignItems: "center",
				},
				"& $absorbItem": {
					width: "350px",
					justifyContent: "flex-start",
					alignItems: "center",
				},
				"& $absorbItemSecond": {
					width: "350px",
					"& $logoWrapper": {
						marginBottom: 0,
					},
				},
				"& $absorbArrowWrapper": {
					margin: "0 16px",
					flexShrink: 0,
				},
				"& $logoWrapper": {
					width: "130px",
					marginBottom: 0,
					marginRight: "24px",
				},
				"& $logo": {
					height: "auto",
					maxHeight: "60px",
				},
				"& $nameWrapper": {
					width: "auto",
				},
				"& $absorbArrowText": {
					marginBottom: 0,
				},
				"& $absorbArrow": {
					transform: "rotate(-90deg)",
					display: "block",
				},
			},
			dropdownButton: {},
			mobileWrapper: {},
		},
		dropdownButton: {},
		mobileWrapper: {},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			root: {
				width: "220px",
				padding: "30px 20px 25px",
			},
			listIsCount2: {},
			listIsHideDescription: {
				"&$listIsCount2": {
					width: "55%",
				},
			},
			logoWrapper: {},
			logo: {},
			logoPlaceholder: {},
			nameWrapper: {},
			name: {},
			isAbsorb: {},
			absorbWrapper: {},
			absorbItem: {},
			absorbItemSecond: {},
			buttonsItemText: {
				fontSize: "12px",
				letterSpacing: "1.5",
			},
			buttons: {
				width: "calc(100% + 20px)",
			},
			isFlat: {
				width: "100%",
				padding: "0 30px",
				"& $logoWrapper": {
					marginBottom: 0,
					width: "110px",
					marginRight: "20px",
					height: "60px",
				},
				"& $logo": {
					height: "auto",
				},
				"& $nameWrapper": {
					minHeight: 0,
					textAlign: "left",
					width: "160px",
					paddingRight: 0,
					marginBottom: "5px",
				},
				"&$isAbsorb": {
					"& $absorbWrapper": {
						flexDirection: "row",
						alignItems: "center",
					},
					"& $absorbItem": {
						width: "350px",
						display: "flex",
						justifyContent: "flex-start",
						flexWrap: "nowrap",
						alignItems: "center",
					},
					"& $absorbItemSecond": {
						width: "350px",
						"& $logoWrapper": {
							marginBottom: 0,
						},
					},
					"& $logoWrapper": {
						marginBottom: 0,
						width: "110px",
					},
					"& $logo": {
						height: "auto",
					},
					"& $nameWrapper": {
						minHeight: 0,
						maxWidth: "100px",
						marginBottom: "5px",
					},
					"& $name": {
						textAlign: "center",
					},
					"& $buttons": {
						minWidth: "200px",
					},
				},
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				width: "170px",
				height: "380px",
				marginRight: "5px",
				marginLeft: "5px",
				marginBottom: "10px",
				padding: "30px 0 0",
			},
			counter: {
				fontSize: "14px",
			},
			logoWrapper: {
				width: "80%",
				height: "60px",
			},
			logo: {},
			nameWrapper: {},
			name: {},
			subtext: {
				fontSize: "12px",
			},
			amountTariffsWrapper: {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
			},
			subtextMeasure: {
				marginTop: "7px",
				fontSize: "14px",
			},
			mainText: {
				fontSize: "18px",
			},
			priceWrapper: {
				marginBottom: "24px",
			},
			buttons: {},
			buttonsItem: {
				height: "50px",
				borderRadius: 0,
				border: "none",
				borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
			},
			buttonsItemText: {
				fontSize: "10px",
				letterSpacing: "1.33",
			},
			isAbsorb: {},
			absorbWrapper: {},
			absorbItem: {},
			absorbItemSecond: {},
			isFlat: {
				width: "100%",
				height: "100px",
				padding: "30px 20px",
				margin: 0,
				"& $logoWrapper": {
					marginBottom: 0,
					width: "110px",
					marginRight: "20px",
					height: "50px",
				},
				"& $logo": {
					height: "40px",
					width: "auto",
					objectFit: "contain",
				},
				"& $subtext": {
					fontSize: "10px",
					marginRight: "20px",
				},
				"& $mainText": {
					fontSize: "24px",
				},
				"& $infoWrapper": {
					flexDirection: "column",
					marginRight: "40px",
				},
				"& $nameWrapper": {
					display: "none",
				},
				"& $buttons": {
					marginTop: 0,
					width: "210px",
					display: "flex",
					marginLeft: "auto",
				},
				"& $buttonsItem": {
					height: "40px",
					borderRadius: "10px",
					width: "100%",
					fontSize: "12px",
					border: `1px solid ${theme.palette.colors.purplishBlue}`,
				},
				"&$isAbsorb": {
					height: "auto",
					padding: "10px 20px",
					"& $absorbWrapper": {
						flexDirection: "row",
						alignItems: "center",
					},
					"& $absorbItem": {
						width: "150px",
						display: "flex",
						justifyContent: "flex-start",
						flexWrap: "nowrap",
						alignItems: "center",
						flexDirection: "column",
					},
					"& $absorbItemSecond": {
						width: "150px",
						"& $logoWrapper": {
							marginBottom: "0",
						},
					},
					"& $logoWrapper": {
						marginBottom: "0",
						width: "110px",
						marginRight: 0,
					},
					"& $logo": {
						height: "auto",
						maxHeight: "40px",
					},
					"& $nameWrapper": {
						minHeight: 0,
						marginBottom: 0,
						maxWidth: "100px",
						display: "block",
						paddingRight: "0",
					},
					"& $name": {
						textAlign: "center",
					},
				},
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				width: "100%",
				height: "auto",
				minHeight: "100px",
				backgroundColor: theme.palette.colors.white,
				marginRight: 0,
				marginLeft: 0,
				padding: "20px 8.33% 70px",
				flexDirection: "row",
				alignItems: "center",
				border: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
				borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
				borderRadius: "10px",
				marginBottom: "16px",
			},
			wrapper: {
				height: "auto",
				flexDirection: "row",
				justifyContent: "space-between",
				marginTop: "12px",
			},
			infoWrapper: {
				flexDirection: "row",
				marginBottom: 0,
			},
			measuresWrapper: {
				display: "flex",
				flexDirection: "column",
				marginBottom: 0,
				width: "110px",
			},
			priceWrapper: {
				display: "flex",
				alignItems: "center",
				width: "110px",
				marginBottom: "5px",
				"& $subtext": {
					marginTop: "-5px",
					marginLeft: "4px",
				},
			},
			speedWrapper: {
				display: "flex",
				alignItems: "center",
				width: "110px",
				"& $subtext": {
					marginTop: "-5px",
					marginLeft: "4px",
				},
			},
			subtext: {
				fontSize: "12px",
			},
			subtextMeasure: {
				position: "relative",
				bottom: "2px",
				marginLeft: "4px",
				marginTop: 0,
				fontSize: "12px",
			},
			mainText: {
				flexDirection: "row",
				alignItems: "flex-end",
				fontSize: "18px",
				marginBottom: "9px",
			},
			counter: {
				display: "none",
			},
			logoWrapper: {
				display: "flex",
				justifyContent: "center",
				marginBottom: 0,
				width: "120px",
				flexShrink: 0,
				height: "60px",
				marginRight: "24px",
			},
			nameWrapper: {
				minHeight: 0,
				textAlign: "left",
				marginBottom: "5px",
			},
			name: {
				textAlign: "left",
			},
			buttons: {
				position: "absolute",
				right: 0,
				left: 0,
				bottom: 0,
				height: "50px",
			},
			buttonsItem: {
				border: "none",
				borderRadius: "0",
				height: "100%",
				borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
			},
			buttonsItemText: {
				fontSize: "12px",
			},
			amountTariffsWrapper: {
				alignItems: "flex-start",
			},
			isElite: {
				border: `solid 1px ${theme.palette.colors.purplishBlue}`,
				borderTop: `solid 1px ${theme.palette.colors.purplishBlue}`,
			},
			absorbWrapper: {},
			absorbArrow: {},
			absorbItem: {},
			absorbItemSecond: {},
			absorbArrowWrapper: {},
			isAbsorb: {
				"& $absorbWrapper": {
					height: "auto",
					flexDirection: "row",
					alignItems: "center",
				},
				"& $absorbItem": {
					width: "40%",
					display: "flex",
					justifyContent: "center",
					flexWrap: "wrap",
					marginRight: "auto",
				},
				"& $absorbItemSecond": {
					width: "40%",
					marginLeft: "auto",
					marginRight: 0,
					"& $logoWrapper": {
						marginBottom: 0,
					},
				},
				"& $absorbArrowWrapper": {
					flexShrink: 0,
				},
				"& $absorbArrow": {
					color: theme.palette.colors.lightGrayishViolet,
					margin: "0 0 0 -12px",
					fontSize: "24px",
					position: "absolute",
					transform: "rotate(-90deg) translateX(50%)",
					left: "50%",
					top: "50%",
				},
				"& $nameWrapper": {
					minHeight: 0,
					marginBottom: 0,
					textAlign: "center",
				},
				"& $name": {
					textAlign: "center",
				},
				"& $logoWrapper": {
					marginBottom: 0,
					width: "100%",
					marginRight: 0,
				},
			},
			isFlat: {
				borderRadius: "10px",
				marginBottom: "16px",
				"& $wrapper": {
					height: "auto",
					flexDirection: "row",
					justifyContent: "space-between",
				},
				"& $infoWrapper": {
					flexDirection: "row",
					marginBottom: 0,
				},
				"& $measuresWrapper": {
					display: "flex",
					marginBottom: 0,
					flexDirection: "column",
				},
				"& $priceWrapper": {
					marginRight: "24px",
					marginBottom: "5px",
				},
				"& $logoWrapper": {
					display: "flex",
					justifyContent: "center",
					marginBottom: 0,
					width: "120px",
					flexShrink: 0,
					height: "60px",
					marginRight: "24px",
				},
				"& $nameWrapper": {
					minHeight: 0,
					width: "auto",
					textAlign: "left",
					marginBottom: "0",
				},
				"& $buttons": {
					position: "absolute",
					right: 0,
					left: 0,
					bottom: 0,
					height: "50px",
					width: "100%",
				},
				"& $buttonsItem": {
					border: "none",
					borderRadius: "0",
					height: "100%",
					borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
				},
				"&$isAbsorb": {
					"& $absorbWrapper": {
						height: "auto",
						flexDirection: "row",
						alignItems: "center",
					},
					"& $absorbItem": {
						width: "40%",
						display: "flex",
						justifyContent: "center",
						flexWrap: "wrap",
						marginRight: "auto",
					},
					"& $absorbItemSecond": {
						width: "40%",
						marginLeft: "auto",
						marginRight: 0,
						"& $logoWrapper": {
							marginBottom: 0,
						},
					},
					"& $absorbArrowWrapper": {
						flexShrink: 0,
						margin: "20px 0",
					},
					"& $absorbArrow": {
						color: theme.palette.colors.lightGrayishViolet,
						margin: "0 0 0 -12px",
						fontSize: "24px",
						position: "absolute",
						transform: "rotate(-90deg) translateX(50%)",
						left: "50%",
						top: "50%",
						marginBottom: 0,
					},
					"& $nameWrapper": {
						minHeight: 0,
						marginBottom: 0,
						textAlign: "center",
						paddingRight: 0,
					},
					"& $name": {
						textAlign: "center",
					},
					"& $logoWrapper": {
						marginBottom: 0,
						width: "100%",
						marginRight: 0,
					},
				},
			},
		},
		[`@media (max-width: ${theme.media.operatorListSmall})`]: {
			infoWrapper: {
				flexDirection: "column",
				height: "80px",
				justifyContent: "space-between",
			},
			logoWrapper: {
				height: "60px",
				marginRight: 0,
				width: "100px",
			},
			nameWrapper: {
				display: "none",
			},
			mobileWrapper: {
				marginLeft: "5%",
			},
			amountTariffsWrapper: {
				display: "flex",
				alignItems: "center",
				flexDirection: "column",
				justifyContent: "center",
			},
			isFlat: {
				"& $infoWrapper": {
					flexDirection: "column",
				},
				"& $logoWrapper": {
					marginRight: 0,
					width: "100px",
				},
				"& $measuresWrapper": {
					display: "block",
				},
				"& $priceWrapper": {
					display: "flex",
					alignItems: "center",
					marginBottom: "5px",
					"& $subtext": {
						marginTop: "-5px",
						marginLeft: "4px",
					},
				},
				"& $speedWrapper": {
					display: "flex",
					alignItems: "center",
					"& $subtext": {
						marginTop: "-5px",
						marginLeft: "4px",
					},
				},
			},
		},
		[`@media (max-width: ${theme.media.xs})`]: {
			wrapper: {
				marginTop: "-5px",
				marginBottom: "16px",
			},
			logoWrapper: {
				marginBottom: "5px",
			},
		},
	};
};
